import { render } from "./ExtraChargeForm.vue?vue&type=template&id=7e739afc"
import script from "./ExtraChargeForm.vue?vue&type=script&lang=js"
export * from "./ExtraChargeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__